import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { ReportFiltersState } from "./types";
import AsyncStorage from "@react-native-async-storage/async-storage";

export const initialValues = {
  selectedStore: "",
  selectedProduct: "",
  selectedAttendant: "",
  selectedServicePoint: ""
};

export const useReportFiltersStore = create<ReportFiltersState>()(
  persist(
    (set) => ({
      ...initialValues,
      setSelectedStoreFilter: (store) => set({ selectedStore: store }),
      setSelectedProductFilter: (product) => set({ selectedProduct: product }),
      setSelectedAttendantFilter: (attendant) =>
        set({ selectedAttendant: attendant }),
      setSelectedServicePointFilter: (servicePoint) =>
        set({ selectedServicePoint: servicePoint }),
      reset: () => set({ ...initialValues })
    }),
    {
      name: "ReportsFiltersStore",
      storage: createJSONStorage(() => AsyncStorage)
    }
  )
);
